module.exports = __webpack_public_path__ + "static/img/12areaB_03.f9a724c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_03.png
// module id = 1104
// module chunks = 1